import { usePremadeQuizzes } from '@quizzach/api-hooks';
import {
	Navigation,
	QuizGrid,
	ShareButton,
	HeroAuthorMark,
} from '@quizzach/components';
import { Reveal } from '@quizzach/motion';
import { AuthorHead, PremadePage } from '@quizzach/styles';
import { scrollToTop } from '@quizzach/utils';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

export const PremadeQuizzesByAuthor = () => {
	const { t } = useTranslation();
	const { author } = useParams();
	const { loading, error, premadeQuizzes, getPremadeQuizzes } =
		usePremadeQuizzes();

	useEffect(() => {
		if (author) {
			getPremadeQuizzes({ author: author });
		}
		scrollToTop();
	}, []);

	if (!premadeQuizzes || premadeQuizzes.length === 0) return null;

	const authorInfo = premadeQuizzes[0].author;
	const shareData = {
		text: t('premade.byAuthor.shareText', {
			author: authorInfo.display_name ?? '',
		}),
		url: `https://quizzach.com/premade/author/${
			authorInfo.display_name_slug ?? 'quizzach'
		}`,
	};

	return (
		<PremadePage>
			<Navigation />

			<AuthorHead>
				<div>
					<Reveal as='h1'>
						{t('premade.byAuthor.title')}
						<br />
						<em>
							<HeroAuthorMark displayName={authorInfo.display_name} />
						</em>
					</Reveal>
					{authorInfo.author_description && (
						<Reveal as='p' className='desc' delay={1}>
							{authorInfo.author_description}
						</Reveal>
					)}
				</div>
				<Reveal className='meta' delay={1}>
					<span className='hand'>
						{t('premade.byAuthor.quizCount')} {premadeQuizzes.length}
					</span>
					<span className='share-full'>
						<ShareButton shareData={shareData} popoverPlacement='down' />
					</span>
					<span className='share-icon'>
						<ShareButton shareData={shareData} iconOnly iconSize={22} />
					</span>
				</Reveal>
			</AuthorHead>

			<QuizGrid quizzes={premadeQuizzes} loading={loading} error={error} />

			<div style={{ paddingBottom: '130px' }} />
		</PremadePage>
	);
};
